var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"antecip-page",attrs:{"grid-list-md":""}},[_c('div',{staticClass:"antecip-card"},[_c('antecipations-header'),_c('div',{staticClass:"antecip-features"},[_c('automatic-antecipation'),_c('manual-antecipation')],1)],1),_c('automatic-anticipation-terms')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }